import React from 'react'
import { useTranslation } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'

import Slider from '@material-ui/core/Slider'
import InputLabel from '@material-ui/core/InputLabel'
import InfoIcon from '@material-ui/icons/Info'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'

export const MaxCloudCoverageSelector = ({
	maxCC,
	handleCloudCoverageChange,
	handleCloudCoverageCommitted,
	info,
	width,
	disabled = false
}) => {
	const { t } = useTranslation()

	const HtmlTooltip = withStyles((theme) => ({
		tooltip: {
			backgroundColor: theme.palette.common.white,
			color: 'rgba(0, 0, 0, 0.87)',
			maxWidth: 220,
			fontSize: theme.typography.pxToRem(14),
			border: '1px solid #dadde9',
		},
	}))(Tooltip)

	return (
		<div style={{ width: width ? width : 300 }}>
			<Grid container alignItems="center">
				<Grid item xs={info ? 10 : 12}>
					<InputLabel id="max-cloud-coverage-label" style={{ fontSize: '0.875rem' }}>
						{t('Max Cloud Coverage')}
					</InputLabel>
				</Grid>
				{info && (
					<Grid item xs={2} style={{ textAlign: 'right' }}>
						<HtmlTooltip
							title={<>{t('Cloud info')}</>}
							placement="right-end"
						>
							<InfoIcon color="primary" />
						</HtmlTooltip>
					</Grid>
				)}
				<Grid item xs={12}>
					<Slider
						value={maxCC}
						onChange={handleCloudCoverageChange}
						onChangeCommitted={handleCloudCoverageCommitted}
						defaultValue={maxCC}
						aria-labelledby="discrete-slider"
						valueLabelDisplay="auto"
						step={0.1}
						marks
						min={0}
						max={1}
						disabled={disabled}
					/>
				</Grid>
			</Grid>
		</div>
	)
}

/*
Clouds affect to the display of the images and the values of the
vegetative indexes you can see on them.
Take into consideration that a cloud coverage above 90% should not be took into account.


*/
